// extracted by mini-css-extract-plugin
module.exports = {"grid":"style_grid__3OWZ9","column":"style_column__iuXej","row":"style_row__311xp"};